<template>
  <div class="detail-box">
    <div class="detail-title">
      <div class="detail-title-big">{{ pageTitle }}</div>
      <div class="detail-title-small">{{ pageTitle }}</div>
    </div>
    <div class="detail-info">
      <div class="detail-info-title">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-for="(item, index) of humList" :key="index">{{ item.meta.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="detail-info-content">
        <div class="detail-info-content-card">
          <div class="detail-info-content-card-swiper">
            <div class="detail-info-content-card-swiper-img">
              <img :src="currentUrl" alt />
              <div class="detail-info-content-card-swiper-img-status">{{ bmzt }}</div>
            </div>
            <div class="detail-info-content-card-swiper-tag-img">
              <div class="swiper-prev" @click="swiperPrev">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div v-for="i of pageInfo.xmTpVOList" :key="i.xmTpId" class="swiper-slide"
                    @click="changeCurrentUrl(i)">
                    <div class="swiper-slide-img-box">
                      <img :src="i.tp" alt />
                    </div>
                  </div>
                </div>
                <!-- Add Pagination -->
                <!-- Add Navigation -->
              </div>
              <div class="swiper-next" @click="swiperNext">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
          <div class="detail-info-content-card-text">
            <div class="detail-info-content-card-text-title">
              <div class="detail-info-content-card-text-title-left">{{ pageInfo.bt }}</div>
              <div class="detail-info-content-card-text-title-right">
                <!-- <div class="detail-info-content-card-text-title-right-item">
                  <img
                    class="detail-info-content-card-text-title-right-item-star"
                    src="./../assets/jsht/detailInfo/star.png"
                    alt
                  />
                  0 人关注
                </div>-->
                <div class="detail-info-content-card-text-title-right-item">
                  <img class="detail-info-content-card-text-title-right-item-eyes"
                    src="./../assets/jsht/detailInfo/eyes.png" alt />
                  {{ pageInfo.readNum }} 次浏览
                </div>
              </div>
            </div>
            <div class="detail-info-content-card-text-center">
              <div class="detail-info-content-card-text-center-left">
                <div class="detail-info-content-card-text-center-je">
                  <div class="detail-info-content-card-text-center-je-title">租赁期限：</div>
                  <div class="detail-info-content-card-text-center-je-num">{{ pageInfo.zlqx }}</div>
                  <div class>年</div>
                </div>
                <div class="detail-info-content-card-text-center-je">
                  <div class="detail-info-content-card-text-center-je-title">租赁面积：</div>
                  <div class="detail-info-content-card-text-center-je-num">{{ pageInfo.zlmj }}</div>
                  <div class>㎡</div>
                </div>
                <div class="detail-info-content-card-text-center-je">
                  <div class="detail-info-content-card-text-center-je-title">挂牌价：</div>
                  <div class="detail-info-content-card-text-center-je-num">{{ pageInfo.gpj }}</div>
                  <div class="detail-info-content-card-text-center-je-dot">元/年</div>
                </div>
                <div class="detail-info-content-card-text-center-je">
                  <div class="detail-info-content-card-text-center-je-title">支付方式：</div>
                  <div class="detail-info-content-card-text-center-je-zffs">{{ pageInfo.zffs }}</div>
                </div>
              </div>
              <div class="detail-info-content-card-text-center-lxr-box">
                <div class="detail-info-content-card-text-center-lxr-img">
                  <img :src="pageInfo.lxrzp" alt />
                </div>
                <div class="detail-info-content-card-text-center-lxr-text">
                  <div class="detail-info-content-card-text-center-lxr-text-item">
                    看样联系人：
                    <span>{{ pageInfo.lxr }}</span>
                  </div>
                  <div class="detail-info-content-card-text-center-lxr-text-item">
                    联系电话：
                    <span>{{ pageInfo.lxdh }}</span>
                  </div>
                  <!-- <div class="detail-info-content-card-text-center-lxr-text-tip">（请在工作日联系，至少提前一天电话预约看样）</div> -->
                  <div class="detail-info-content-card-text-center-lxr-text-tip">
                    {{ pageInfo.kysj }}
                  </div>
                </div>
              </div>
            </div>
            <div class="detail-info-content-card-text-status">
              <div class="detail-info-content-card-text-status-text">{{ bmzt }}</div>
              <div class="detail-info-content-card-text-status-time">报名截止时间：{{ pageInfo.bmjzsj }}</div>
              <div class="detail-info-content-card-text-status-tel">报名咨询电话：{{ pageInfo.bmzxdh }}</div>
            </div>
            <div class="detail-info-content-card-text-button">
              <div class="detail-info-content-card-text-button-text">报名交保证金</div>
              <div class="detail-info-content-card-text-button-title">保证金：</div>
              <div class="detail-info-content-card-text-button-num">{{ pageInfo.bzj }}</div>
              <div class="detail-info-content-card-text-button-dot">元</div>
            </div>
          </div>
        </div>
        <div class="detail-info-content-lc"></div>
        <div class="detail-info-content-tips">
          <div class="detail-info-content-tips-title">特别提示：</div>
          <div class="detail-info-content-tips-detail">
            本平台为第三方交易信息平台，仅对挂牌方喝/或招标方的相关资质进行审核。项目公告以及相关信息、图片、视频、附件等，均由挂牌方、招标方自行负责发布、上传，并承担相应法律责任。本平台对项目公告等各项信息、素材不承担审核义务法律责任。对交易成交的项目，本平台不强制挂牌机构（单位）提供退换服务。
          </div>
        </div>
        <div class="detail-info-content-tabs">
          <div class="detail-info-content-tabs-title">
            <div :class="['detail-info-content-tabs-title-item', activeIndex === 1 ? 'active' : '']"
              @click="changeTab(1)">
              交易公告
              <div v-if="activeIndex === 1" class="detail-info-content-tabs-title-item-bottom"></div>
            </div>
            <div :class="['detail-info-content-tabs-title-item', activeIndex === 2 ? 'active' : '']"
              @click="changeTab(2)">
              交易须知
              <div v-if="activeIndex === 2" class="detail-info-content-tabs-title-item-bottom"></div>
            </div>
            <div :class="['detail-info-content-tabs-title-item', activeIndex === 3 ? 'active' : '']"
              @click="changeTab(3)">
              地理位置
              <div v-if="activeIndex === 3" class="detail-info-content-tabs-title-item-bottom"></div>
            </div>
            <div :class="['detail-info-content-tabs-title-item', activeIndex === 4 ? 'active' : '']"
              @click="changeTab(4)">
              附件下载
              <div v-if="activeIndex === 4" class="detail-info-content-tabs-title-item-bottom"></div>
            </div>
          </div>
          <div class="detail-info-content-tabs-detail" v-if="activeIndex === 1" v-html="pageInfo.jygg"></div>
          <div class="detail-info-content-tabs-detail" v-if="activeIndex === 2" v-html="pageInfo.jyxz"></div>
          <div class="detail-info-content-tabs-detail" v-if="activeIndex === 3">
            <div id="container"></div>
          </div>
          <div class="detail-info-content-tabs-detail" v-if="activeIndex === 4" v-html="pageInfo.fjxz"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'

export default {
  components: {},
  data() {
    return {
      swiperItem: null,
      activeIndex: 1,
      humList: [],
      pageTitle: '',
      pageInfo: {},
      bmzt: '',
      currentUrl: ''
    }
  },
  mounted() {
    this.swiperItem = new Swiper('.swiper-container', {
      // Swiper options
      loop: true,
      slidesPerView: '5',
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev'
      }
    })
    this.humList = [
      ...this.$Lockr.get('fromPage'),
      ...this.$Lockr.get('toPage')
    ]
    this.getDetail(this.$route.params.id)

  },
  methods: {
    changeTab(i) {
      this.activeIndex = i
      if (i === 3) {
        this.setMap()
      }
    },
    changeCurrentUrl(item) {
      this.currentUrl = item.tp
    },
    getDetail(id) {
      this.axios.get(`https://admin.jshtcq.com/api/sy/xm/${id}`).then(res => {
        switch (res.data.data.category) {
          case 1:
            this.pageTitle = '资产转让'
            // 执行代码块 1
            break
          case 2:
            this.pageTitle = '资产转让'
            // 执行代码块 2
            break
          case 3:
            this.pageTitle = '资产转让'
            // 执行代码块 2
            break
          case 4:
            this.pageTitle = '资产转让'
            // 执行代码块 2
            break
          case 5:
            this.pageTitle = '资产转让'
            // 执行代码块 2
            break
          case 6:
            this.pageTitle = '资产租赁'
            // 执行代码块 2
            break
          case 7:
            this.pageTitle = '资产租赁'
            // 执行代码块 2
            break
          case 8:
            this.pageTitle = '资产租赁'
            // 执行代码块 2
            break
          case 9:
            this.pageTitle = '资产租赁'
            // 执行代码块 2
            break
          case 10:
            this.pageTitle = '综合交易'
            // 执行代码块 2
            break
          case 11:
            this.pageTitle = '综合交易'
            // 执行代码块 1
            break
          case 12:
            this.pageTitle = '综合交易'
            // 执行代码块 2
            break
          case 13:
            this.pageTitle = '综合交易'
            // 执行代码块 2
            break
          case 14:
            this.pageTitle = '农村产权'
            // 执行代码块 2
            break
          case 15:
            this.pageTitle = '农村产权'
            // 执行代码块 2
            break
          case 16:
            this.pageTitle = '农村产权'
            // 执行代码块 2
            break
          case 17:
            this.pageTitle = '农村产权'
            // 执行代码块 2
            break
          case 18:
            this.pageTitle = '阳光招标'
            // 执行代码块 2
            break
          case 19:
            this.pageTitle = '阳光招标'
            // 执行代码块 2
            break
          case 20:
            this.pageTitle = '成交公示'
            // 执行代码块 2
            break
          default:
            // 如果没有匹配到任何 case，则执行默认代码块
            break
        }
        switch (res.data.data.xxzt) {
          case 1:
            this.bmzt = '正在报名'
            // 执行代码块 1
            break
          case 2:
            this.bmzt = '报名已截止'
            // 执行代码块 2
            break
          case 3:
            this.bmzt = '正在竞价'
            // 执行代码块 2
            break
          case 4:
            this.bmzt = '已成交'
            // 执行代码块 2
            break
          case 5:
            this.bmzt = '已终止'
            // 执行代码块 2
            break
          case 6:
            this.bmzt = '已撤牌'
            // 执行代码块 2
            break

          default:
            // 如果没有匹配到任何 case，则执行默认代码块
            break
        }
        this.pageInfo = res.data.data
        this.currentUrl = this.pageInfo.xmTpVOList[0]?.tp

      })
    },
    setMap() {
      setTimeout(() => {
        let pointList = this.pageInfo.lnglat.split(',')
        var map = new BMapGL.Map('container');
        var point = new BMapGL.Point(parseFloat(pointList[0]), parseFloat(pointList[1]));
        map.centerAndZoom(point, 15);
        map.enableScrollWheelZoom(true);
        // 创建点标记
        var marker = new BMapGL.Marker(point);

        map.addOverlay(marker);
        // // 创建信息窗口
        // var opts = {
        //   width: 200,
        //   height: 100,
        //   title: '故宫博物院'
        // };
        // var infoWindow = new BMapGL.InfoWindow('地址：北京市东城区王府井大街88号乐天银泰百货八层', opts);
        // // 点标记添加点击事件
        // marker.addEventListener('click', function () {
        //   map.openInfoWindow(infoWindow, point); // 开启信息窗口
        // });
      })
    },
    swiperPrev() {
      this.swiperItem.slidePrev()
    },
    swiperNext() {
      this.swiperItem.slideNext()
    }
  }
}
</script>

<style lang="scss" scoped>
#container {
  height: 600px;
  overflow: hidden;
  width: 100%;
  margin: 0;
}

.detail-box {
  background: #f7f7f7;

  .detail-title {
    width: 100%;
    height: 250px;
    background: url('./../assets/jsht/detail/detail_top_bg.png') left top no-repeat;
    background-size: 100% 100%;
    position: relative;

    .detail-title-big {
      font-family: YouSheBiaoTiHei;
      font-size: 150px;
      color: rgba(0, 101, 240, 0.12);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      height: 195px;
      line-height: 195px;
      margin-top: 16px;
    }

    .detail-title-small {
      font-family: YouSheBiaoTiHei;
      font-size: 52px;
      color: #0c6aec;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      height: 68px;
      line-height: 68px;
      margin-top: 108px;
    }
  }

  .detail-info {
    padding: 0 240px;

    .detail-info-title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 52px;

      .detail-info-title-right {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
      }
    }

    .detail-info-content {
      .detail-info-content-card {
        padding: 20px;
        background: #ffffff;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        .detail-info-content-card-swiper {
          width: 380px;
          height: 367px;
          background: #ffffff;
          border-radius: 8px;
          border: 1px solid #dedee5;
          overflow: hidden;

          .detail-info-content-card-swiper-img {
            width: 380px;
            height: 285px;
            background: #ebebef;
            position: relative;

            img {
              width: 100%;
              height: 100%;
            }

            .detail-info-content-card-swiper-img-status {
              height: 32px;
              background: #3793ff;
              color: #ffffff;
              font-weight: bold;
              font-size: 15px;
              line-height: 32px;
              color: #ffffff;
              padding: 0 16px;
              position: absolute;
              right: 0;
              top: 0;
            }
          }

          .detail-info-content-card-swiper-tag-img {
            margin-top: 15px;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
            color: #39b7ff;
            font-size: 16px;

            .swiper-prev {
              cursor: pointer;
            }

            .swiper-next {
              cursor: pointer;
            }

            .swiper-container {
              width: 312px;
              height: 44px;
              overflow: hidden;

              .swiper-wrapper {
                .swiper-slide {
                  width: 56px !important;
                  height: 44px;
                  cursor: pointer;

                  &+.swiper-slide {
                    margin-left: 8px;
                  }

                  .swiper-slide-img-box {
                    width: 56px;
                    height: 44px;

                    img {
                      width: 100%;
                      height: 100%;
                    }
                  }
                }
              }
            }
          }
        }

        .detail-info-content-card-text {
          margin-left: 12px;
          flex: 1;

          .detail-info-content-card-text-title {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;

            .detail-info-content-card-text-title-left {
              font-weight: bold;
              font-size: 20px;
              color: #1e1e1e;
              flex: 1;
            }

            .detail-info-content-card-text-title-right {
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
              align-items: center;

              .detail-info-content-card-text-title-right-item {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                font-weight: 400;
                font-size: 16px;
                color: #0c6aec;
                line-height: 25px;

                &+.detail-info-content-card-text-title-right-item {
                  margin-left: 40px;
                }

                .detail-info-content-card-text-title-right-item-star {
                  width: 26px;
                  height: 25px;
                  margin-right: 8px;
                }

                .detail-info-content-card-text-title-right-item-eyes {
                  width: 24px;
                  height: 17px;
                  margin-right: 8px;
                }
              }
            }
          }

          .detail-info-content-card-text-center {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-top: 25px;

            .detail-info-content-card-text-center-left {
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              margin-left: 12px;

              .detail-info-content-card-text-center-je {
                &+.detail-info-content-card-text-center-je {
                  margin-top: 9px;
                }

                // margin-top: 5px;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-end;
                height: 24px;

                .detail-info-content-card-text-center-je-title {
                  font-weight: 400;
                  font-size: 16px;
                  height: 16px;
                  line-height: 16px;
                  color: #898989;
                }

                .detail-info-content-card-text-center-je-num {
                  font-weight: bold;
                  font-size: 24px;
                  height: 24px;
                  line-height: 24px;
                  color: #e20e0e;
                }

                .detail-info-content-card-text-center-je-zffs {
                  font-weight: bold;
                  font-size: 16px;
                  height: 16px;
                  line-height: 16px;
                  color: #0c6aec;
                }

                .detail-info-content-card-text-center-je-dot {
                  font-weight: 400;
                  font-size: 16px;
                  height: 16px;
                  line-height: 16px;
                  color: #e20e0e;
                }
              }
            }

            .detail-info-content-card-text-center-lxr-box {
              width: 495px;
              height: 126px;
              background: #ffffff;
              border-radius: 8px;
              border: 1px solid #0c6aec;
              padding: 16px 25px;
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;

              .detail-info-content-card-text-center-lxr-img {
                width: 76px;
                height: 95px;
                background: #d8d8d8;

                img {
                  width: 100%;
                  height: 100%;
                }
              }

              .detail-info-content-card-text-center-lxr-text {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: 100%;
                margin-left: 16px;

                .detail-info-content-card-text-center-lxr-text-item {
                  font-weight: 400;
                  font-size: 15px;
                  color: #898989;

                  span {
                    font-weight: 400;
                    font-size: 15px;
                    color: #1e1e1e;
                  }
                }

                .detail-info-content-card-text-center-lxr-text-tip {
                  font-weight: 400;
                  font-size: 13px;
                  color: #e20e0e;
                }
              }
            }
          }

          .detail-info-content-card-text-status {
            height: 74px;
            width: 100%;
            background: url('./../assets/jsht/detailInfo/status_bg.png') top left no-repeat;
            background-size: 100% 100%;
            margin-top: 20px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            .detail-info-content-card-text-status-text {
              width: 130px;
              height: 74px;
              background: #3793ff;
              border-radius: 8px 0px 0px 8px;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              font-weight: bold;
              font-size: 22px;
              color: #ffffff;
            }

            .detail-info-content-card-text-status-time {
              font-weight: bold;
              font-size: 16px;
              color: #0c6aec;
              margin-left: 28px;
            }

            .detail-info-content-card-text-status-tel {
              font-weight: bold;
              font-size: 16px;
              color: #0c6aec;
              margin-left: 120px;
            }
          }

          .detail-info-content-card-text-button {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            height: 74px;
            margin-top: 18px;

            .detail-info-content-card-text-button-text {
              width: 290px;
              height: 74px;
              background: #ff6e25;
              border-radius: 8px;
              font-weight: bold;
              font-size: 24px;
              color: #ffffff;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
            }

            .detail-info-content-card-text-button-title {
              font-weight: 400;
              font-size: 18px;
              color: #898989;
              margin-left: 30px;
            }

            .detail-info-content-card-text-button-num {
              font-weight: bold;
              font-size: 32px;
              color: #e20e0e;
            }

            .detail-info-content-card-text-button-dot {
              font-weight: 400;
              font-size: 18px;
              color: #e20e0e;
            }
          }
        }
      }

      .detail-info-content-lc {
        background: url('./../assets/jsht/detailInfo/xmlc.png') left top no-repeat;
        background-size: 100% 100%;
        height: 80px;
        margin-top: 18px;
      }

      .detail-info-content-tips {
        height: 120px;
        background: #e4f2ff;
        border-radius: 8px;
        border: 1px solid #0c6aec;
        padding: 22px 26px;
        margin-top: 18px;

        .detail-info-content-tips-title {
          font-weight: bold;
          font-size: 18px;
          color: #1e1e1e;
          height: 18px;
          line-height: 18px;
        }

        .detail-info-content-tips-detail {
          font-weight: 400;
          font-size: 16px;
          color: #636363;
          line-height: 24px;
          margin-top: 8px;
        }
      }

      .detail-info-content-tabs {
        background: #ffffff;
        margin-top: 24px;
        margin-bottom: 30px;

        .detail-info-content-tabs-title {
          height: 60px;
          border-bottom: 1px solid #ebebeb;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;

          .detail-info-content-tabs-title-item {
            width: 150px;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            position: relative;

            &.active {
              background: #eff6ff;
            }

            .detail-info-content-tabs-title-item-bottom {
              position: absolute;
              bottom: 0;
              height: 6px;
              width: 100%;
              left: 0;
              background: #0c6aec;
            }
          }
        }

        .detail-info-content-tabs-detail {
          padding: 12px;
          margin-bottom: 16px;

          ::v-deep {

            img {
              max-width: 100%;
            }
            table {
              border-top: 1px solid #ccc;
              border-left: 1px solid #ccc;
            }

            table td,
            table th {
              border-bottom: 1px solid #ccc;
              border-right: 1px solid #ccc;
              padding: 3px 5px;
            }

            table th {
              border-bottom: 2px solid #ccc;
              text-align: center;
            }

            // img {
            //   width: 100%;
            // }
          }

        }
      }
    }
  }
}
</style>